module.exports = __webpack_public_path__ + "img/minHacienda.3e183457.png";